/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ExpireOKIcon extends BaseIcon {
  getChildren = () => [
    <g>
      <circle fill='#56b40a' cx="21.1" cy="21.02" r="19.5"/>
      <path fill='#fff' d="M21.1,3a18,18,0,1,1-18,18,18,18,0,0,1,18-18m0-3a21,21,0,1,0,21,21,21,21,0,0,0-21-21Z"/>
      <path fill='#fff'
            d="M30.81,17.3l-11.95,12h0a2.57,2.57,0,0,1-3.63,0h0L9.78,23.8a2.57,2.57,0,1,1,3.63-3.63l3.64,3.64L27.18,13.68a2.56,2.56,0,0,1,3.63,3.62Z"/>
    </g>
  ]
  getViewBox = () => '0 0 42 42'
}
